/*
setTitle = function (title) {
	var obj = $('title');
	obj.html(title + ' | ' + obj.html());
};
*/

function copyToClipboard(button, element) {
	$(button).fadeOut(100);
	$(button).fadeIn(100);
	let text = $(element).clone().find('br').prepend('\r\n').end().text().trim();
	navigator.clipboard.writeText(text);
}



$(function ($) {

	/** Lightbox */
	//http://dimsemenov.com/plugins/magnific-popup/documentation.html
	$('.gallery').each(function () { // the containers for all your galleries
		$(this).magnificPopup({
			delegate: 'a.magnific', // the selector for gallery item
			type: 'image',
			gallery: {
				enabled: true
			},
			image: {
				titleSrc: 'title' // Attribute of the target element that contains caption for the slide.
				// Or the function that should return the title. For example:
				// titleSrc: function(item) {
				//   return item.el.attr('title') + '<small>by Marsel Van Oosten</small>';
				// }
			}
		});
	});

	//catch all clicks on a tags
	$("a").not("#tabs a").not(".noscroll, .nav a").click(function () {
		//check if it has a hash (i.e. if it's an anchor link)
		if (this.hash) {
			const hash = this.hash.substring(1);
			const element = $("[id=" + hash + "]");
			if (element.length) {
				const toPosition = element.offset().top - 15;
				//scroll to element
				$("body,html").animate({
					scrollTop: toPosition
				}, 500, "easeInOutCubic", function () {
					element.animate({backgroundColor: "rgba(167,217,106,0.5)"}, 500, "easeInOutCubic", function () {
						element.animate({backgroundColor: "transparent"}, 2000, "easeInOutCubic");
					});
				});
			}
		}
	});


	/** Horni menu efekt */
	if ($(window).scrollTop() >= 35) {
		$("#content > nav").css({
			"background-image": "none",
			"border": "0",
			"background-color": "#ffffff",
			"box-shadow": "0px 0px 20px rgba(0,0,0,0.2)"
		});
	} else {
		$("#content > nav").css({
			"background-image": "none",
			"border": "0",
			"background-color": "transparent",
			"box-shadow": "none"
		});
	}
	$(window).scroll(function () {
		if ($(window).scrollTop() >= 35) {
			$("#content > nav").css({
				"background-color": "#ffffff",
				"box-shadow": "0px 0px 20px rgba(0,0,0,0.2)",
				"-moz-transition": "all 0.2s ease-in",
				"-webkit-transition": "all 0.2s ease-in",
				"-o-transition": "all 0.2s ease-in",
				"transition": "all 0.2s ease-in"
			});
		} else {
			$("#content > nav").css({
				"background-color": "transparent",
				"box-shadow": "none",
				"-moz-transition": "all 1s ease-in",
				"-webkit-transition": "all 1s ease-in",
				"-o-transition": "all 1s ease-in",
				"transition": "all 1s ease-in"
			});
		}
	});


	/* ::::: STYLY :::::: */
	var obj = $('.container.front-styl-list .item .inner');
	obj.mouseover(function () {
		$(this).find('.infobox').removeClass('dn');
	});
	obj.mouseout(function () {
		$(this).find('.infobox').addClass('dn');
	});
});

/* přesunuto do modulu aja-modal.js
	zde ponecháno kvůli populateModal, které se aktuálně nepoužívá, ale mohlo by v budoucnu
const ajaxModalEl = document.getElementById('ajax-modal');
ajaxModalEl.addEventListener('show.bs.modal', (e) => {
	const modal = e.target;
	modal.querySelector('.modal-title').innerHTML = 'Načítám… <i class="fas fa-spinner fa-spin"></i>';
	const subtitle = modal.querySelector('.modal-subtitle');
	if(subtitle) {
		subtitle.innerHTML = '';
	}
	modal.querySelector('.modal-body').innerHTML = '';
	if (e.relatedTarget.dataset.bsModalSize) {
		modal.querySelector('.modal-dialog').classList.add('modal-' + e.relatedTarget.dataset.bsModalSize);
	}
	if (e.relatedTarget.dataset.bsModalTemplate) {
		populateModal(modal, e.relatedTarget.dataset.bsModalTemplate);
	}
});
*/
const ajaxOffcanvasEl = document.getElementById('ajax-offcanvas');
if (ajaxOffcanvasEl) {
	ajaxOffcanvasEl.addEventListener('show.bs.offcanvas', (e) => {
		const offcanvas = e.target;
		offcanvas.querySelector('.offcanvas-header').innerHTML = '<span>Načítám… <i class="fas fa-spinner fa-spin"></i></span>';
		offcanvas.querySelector('.offcanvas-body').innerHTML = '';
		if (e.relatedTarget.dataset.bsOffcanvasSize) {
			const size = e.relatedTarget.dataset.bsOffcanvasSize;
			switch (size) {
				case 'xl':
					offcanvas.classList.add('w-75');
					break;
				case 'l':
					offcanvas.classList.add('w-50');
					break;
			}
		}
		if (e.relatedTarget.dataset.bsOffcanvasTemplate) {
			populateOffcanvas(offcanvas, e.relatedTarget.dataset.bsOffcanvasTemplate);
		}
	});
}

function populateModal(modal, templateId) {
	const template = document.getElementById(templateId);
	const content = template.content;

	const titleContentElement = content.querySelector('.modal-title-content');
	if (titleContentElement) {
		modal.querySelector('.modal-title').innerHTML = titleContentElement.innerHTML;
	}

	const bodyContentElement = content.querySelector('.modal-body-content');
	if (bodyContentElement) {
		modal.querySelector('.modal-body').innerHTML = bodyContentElement.innerHTML;
	}

	const footerContentElement = content.querySelector('.modal-footer-content');
	if (footerContentElement) {
		modal.querySelector('.modal-footer').innerHTML = footerContentElement.innerHTML;
	}
}